export default __webpack_public_path__ + "static/media/20_footer_quotation.a32d295e.png";